import { render, staticRenderFns } from "./roleAssign.vue?vue&type=template&id=29a02c35&scoped=true"
import script from "./roleAssign.vue?vue&type=script&lang=js"
export * from "./roleAssign.vue?vue&type=script&lang=js"
import style0 from "./roleAssign.vue?vue&type=style&index=0&id=29a02c35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a02c35",
  null
  
)

export default component.exports